import { useNavigate } from 'react-router-dom';
import NeuralQuest from '../components/NeuralQuest';
import { MMEMParams } from '../types';
import { motion } from 'motion/react';
import SEO from '../components/SEO';

interface GamePageProps {
  params: MMEMParams;
}

export default function GamePage({ params }: GamePageProps) {
  const navigate = useNavigate();

  return (
    <div className="bg-background h-dvh w-full overflow-hidden">
      <SEO
        title="Play Neural Quest | Memory Challenge"
        description="Challenge your memory encoding strength. A gamified experience based on the Mojolagbe Memory Encoding Model (MMEM)."
      />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="h-full"
      >
        <NeuralQuest
          params={params}
          onBack={() => navigate('/model-playground')}
        />
      </motion.div>
    </div>
  );
}
